// extracted by mini-css-extract-plugin
export default {"Hero":"LayoutHero_Hero__bK9Xq","Layout":"LayoutHero_Layout__swo9y","LayoutCenter":"LayoutHero_LayoutCenter__DgIxO"};